import moment from 'moment';
import { dateTimeFormatter } from '../../../utils/formatters';

const TOKEN_PARTIAL_MASK = '***';

export const maskProviderToken = value => {
  if (!value) {
    return '';
  }

  const token = String(value);
  if (!token.replace(/\*/g, '')) {
    return token;
  }
  if (token.includes(TOKEN_PARTIAL_MASK)) {
    return token;
  }

  if (token.length >= 6) {
    return `${token.slice(0, 3)}${TOKEN_PARTIAL_MASK}${token.slice(-3)}`;
  }
  if (token.length <= 3) {
    return TOKEN_PARTIAL_MASK;
  }

  const visibleLength = token.length === 4 ? 1 : 2;
  return `${token.slice(0, visibleLength)}${TOKEN_PARTIAL_MASK}${token.slice(-visibleLength)}`;
};

export const providerColumns = [
  {
    dataField: 'id',
    text: 'Id',
    disableSort: true,
  },
  {
    dataField: 'name',
    text: 'name',
    disableSort: true,
  },
  {
    dataField: 'token',
    text: 'Токен',
    disableSort: true,
    formatter: (_, item) => (item?.has_token ? maskProviderToken(item?.token_display || item?.token) : ''),
  },
  {
    dataField: 'created_at',
    text: 'created_at',
    disableSort: true,
    formatter: dateTimeFormatter,
  },
];

export const providerAdditionalColumns = [];
